module.exports = __webpack_public_path__ + "static/assets/f28b1ecd6fccd6218a837c14b1109da7.mp3";